import {
	useGetModernizeChangeboardingOnboardingState,
	useSetModernizeChangeboardingOnboardingState,
} from '../../hooks/useModernizeChangeboardingOnboardingState.ts';

export const useLiveDocModal = () => {
	const { loading, error, hasDismissedLiveDocModal, hasDismissedLiveDocTour } =
		useGetModernizeChangeboardingOnboardingState();

	const { completeLiveDocModal } = useSetModernizeChangeboardingOnboardingState();

	const onCloseModal = () => {
		completeLiveDocModal();
	};

	if (loading) {
		return { isEligibleToSeeModal: false, onCloseModal: () => {}, loading: true };
	}

	if (error) {
		return { isEligibleToSeeModal: false, onCloseModal: () => {}, error };
	}

	const isEligibleToSeeModal = !hasDismissedLiveDocModal && !hasDismissedLiveDocTour;

	return { isEligibleToSeeModal, onCloseModal };
};
